function recentViewProduct() {
    console.log("recently...!");

    if (document.querySelector('.recentView-main')) {
        console.log("product-view!!!!");

        if (window.location.href.includes("products") || window.location.href.includes("cart")) {
            const productHandle = productData.product_handle;
            let productList = JSON.parse(localStorage.getItem('recentlyViewedProduct')) || [];
            console.log("productList",productList);
            if (!productList.includes(productHandle) && productHandle !== '/products/') {
                productList.push(productHandle);
            }

            localStorage.setItem('recentlyViewedProduct', JSON.stringify(productList));
            let reversedArray = [...productList].reverse();
            console.log("reversedArray",reversedArray);
            let requests = reversedArray.map(currentProductHandle => {
              console.log("requests",currentProductHandle);
                if (window.location.pathname !== window.routes.cart_url && currentProductHandle && !currentProductHandle.includes(productHandle)) {
                    let productTileTemplateUrl = `${currentProductHandle}?view=card`;
                  console.log("productTileTemplateUrl",productTileTemplateUrl);
                    return fetch(productTileTemplateUrl).then(res => res.status === 200 ? res.text() : '');
                }
            });
        
            let recentViewLocalStorage = localStorage.getItem('recentlyViewedProduct');
            console.log("recentViewLocalStorage",recentViewLocalStorage);
          
            if (recentViewLocalStorage !== '["/products/"]') {
                Promise.all(requests).then(responses => {
                  console.log("responses",responses);
                    let recentViewCard = responses.join('');
                    console.log("recentViewCard",recentViewCard);
                    if (recentViewCard.trim()) {
                        document.querySelector(".recentView-main").classList.remove("d-none");
                    }

                    const grid = document.querySelector(".recentgrid");
                  console.log("grid");
                    grid.innerHTML = recentViewCard;

                   /*  let tooltipTriggerList = grid.querySelectorAll('[data-bs-toggle="tooltip"]');
                    window.initTooltips(tooltipTriggerList); */
                    //SectionLoadProductReviews();

                 document.querySelectorAll(".recentgrid > .product-box").forEach(box => {
                        box.classList.remove("col");
                        box.classList.add("swiper-slide");
                    });

                    new Swiper('.recentviewproduct-main-grid', {
                        speed: 500,
                        autoplay: recentSlider.autoplay,
                        navigation: {
                            nextEl: ".recent-slider-wrapper .swiper-button-next",
                            prevEl: ".recent-slider-wrapper .swiper-button-prev"
                        },
                        pagination: {
                            el: ".recent-slider-wrapper .swiper-pagination",
                            clickable: true
                        },
                        breakpoints: {
                            320: { slidesPerView: recentSlider.view_mobile },
                            768: { slidesPerView: recentSlider.view_tablet },
                            992: { slidesPerView: recentSlider.view_mini_desktop },
                            1200: { slidesPerView: recentSlider.view_desktop }
                        }
                    });

                   // window.initVariantChanger();

                    document.querySelectorAll(".product-box .box-inner").forEach(box => {
                        box.addEventListener("mouseenter", () => box.classList.add("item-hover"));
                        box.addEventListener("mouseleave", () => box.classList.remove("item-hover"));
                    });
                });
            }
        }
    }
}

recentViewProduct(); 

